import {useAppSelector} from '@/hooks';
import {getCurrentPageItems} from '@Components/poster-editor/poster-editor-reducer';
import {useEffect, useState} from 'react';
import {MIN_PAGE_DURATION} from '@PosterWhiteboard/libraries/video-page';

export function useGetPageMinDuration(): number {
  const currentPageItems = useAppSelector(getCurrentPageItems);
  const [minDuration, setMinDuration] = useState(MIN_PAGE_DURATION);

  useEffect(() => {
    const duration = window.posterEditor?.whiteboard?.getCurrentPage().items.getMaxAnimationTime();
    if (duration && duration !== minDuration) {
      setMinDuration(duration);
    }
  }, [currentPageItems]);

  return minDuration;
}
